export default __webpack_public_path__ + "files/0ab7d0cb2c05ed08a3c5483942ee3fb7.mp3";